import { Badge } from '@chakra-ui/react'

export const ItemBadge = ({ children, ...props }) => {
  return (
    <Badge
      textTransform="uppercase"
      fontSize="11px"
      fontWeight="bold"
      padding="1px 10px"
      borderRadius={100}
      {...props}
    >
      {children}
    </Badge>
  )
}
